import { Button } from "antd";
import { Link } from "react-router-dom";
import CheckedIcon from "../../../../assets/web/icons/CheckedIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import { CustomModalProps } from "../../../../types";

type Props = {
  type?: "report" | "queue";
} & CustomModalProps;

export default function SuccessModal({ type = "report", ...rest }: Props) {
  return (
    <CustomModal title="" footer={null} width={400} closeIcon={null} {...rest}>
      <div className="flex justify-center text-center items-center">
        <div className="text-center">
          <div className="flex justify-center text-center items-center">
            <CheckedIcon />
          </div>
          <div className="text-center justify-center text-zinc-700 text-base font-medium py-5">
            {type === "queue"
              ? "Task Request has been submitted for processing"
              : "Report Request has been submitted for processing"}
          </div>
          <Link to={type === "queue" ? "/admin/task-queue" : "/admin/reports"}>
            <Button type="primary" className="min-w-[100px]">
              Okay
            </Button>
          </Link>
        </div>
      </div>
    </CustomModal>
  );
}
